var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',[_c('Nav'),_c('Banner'),_c('Main'),_c('Footer')],1),_c('transition',{attrs:{"name":"mask"}},[(_vm.show)?_c('div',{staticClass:"mask"},[_c('img',{attrs:{"src":require("@/assets/loading.gif"),"alt":""}})]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }